module.exports = __webpack_public_path__ + "img/blingrock.c264bcf3.png";